module.exports = __webpack_public_path__ + "static/media/icons.00a94d1c.svg";